// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

/* bootstrap vue */
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

/* scroll to */
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
	offset: window.width > 991 ? 112 : -128,
	cancelable: false
})

/* scroll view */
import ScrollView from 'vue-scrollview'
Vue.use(ScrollView, {
	offset: 100
})

/* promise polyfill */
import { polyfill } from 'es6-promise';
polyfill();

/* google analytics */
import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
  id: 'UA-112119644-20',
  router
})

/* creo changes in index.html lang attribute*/
import Creo from './plugins/creo'
Vue.use(Creo, {lang: document.documentElement.lang})

/* app */
new Vue({
	el: '#app',
	router,
	components: { App },
	template: '<App/>'
})
